
export enum MoreOptionsEnum {
    DETAIL = 1,
    DOWNLOAD_SERVICE_REPORT = 2,
    EDIT = 3,
    CANCEL = 4,
    DOWNLOAD_ECONOMIC_REPORT = 5
}
